import React, { useEffect, useRef, useState } from 'react'
import './Register.css';
import { LoginService } from '../services/LoginService';
import AppSettings from '../services/AppSettings';
import useEffectOnce from '../hooks/useEffectOnce';
import { Dispatch } from 'redux';
import { passwordapi } from '../ApiNames';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { InputText } from 'primereact/inputtext';
import { GFNButton } from '../ui/GFNButton';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Link } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { fetchData, register } from '../reduxactions/RegisterActions';
import { useNavigate } from 'react-router-dom';
var imageName = require('./../assets/img/gfn.png');


export const Register = () => {

  const uid = window.sessionStorage.getItem('uid');
  const dispatch = useDispatch();
  const [datas, setDatas] = useState<any>()
  //To get countries data
  const getcountry = async () => {
    //removed from reducer due to storage of array error in store
    /**
     * Author: Manikanta Kummarapurugu
      Email: kmanikanta4321@gmail.com
     * Date: 2025-01-29
     * Manikanta Kummarapurugu, phone:7032797119
     */

    // await dispatch(fetchData(uid) as any);
    const payload = { uid: uid };
    const apiname = passwordapi.getcountrys;
    const response = await LoginService.getData(apiname, payload);
    setDatas(response)
  };

  useEffectOnce(() => {
    getcountry()
  }, [dispatch])

  interface LoginData {
    firstname: string;
    lastname: string;
    email: string;
    password: string;
    usertype: string;
    checked: any;
  };

  const [usertype, setusertype] = useState('');
  const [firstname, setfirstname] = useState('');
  const [lastname, setlastname] = useState('');
  const [email, setemail] = useState('');
  const [password, setpassword] = useState('');
  const [country, setcountry] = useState('');
  const [checked, setChecked] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});


  const useroptions = [
    { labels: 'Donor', value: 'donor' },
    { labels: 'Fundmanager', value: 'fundmanager' },
    { labels: 'Organisation', value: 'organisation' },
  ];

  // const datas = useSelector((state: RootState) => state.register.countrydata) || [];
  const regdatas = useSelector((state: RootState) => state.register.regdata);
  console.log("regdatas", regdatas)
  //toast code
  const navigate = useNavigate();
  const toast = useRef(regdatas);
  useEffect(() => {
    if (regdatas !== '' && regdatas !== undefined && regdatas !== null && regdatas !== 'undefined' && regdatas.length > 0) {
      if (regdatas !== "user already existed") {
        toast.current.show({ severity: 'success', summary: '', detail: regdatas, life: 3000 })
      } else {
        toast.current.show({ severity: 'error', summary: '', detail: regdatas, life: 3000 })
      }
    }

  }, [regdatas]);
  const regsdata = async () => {
    try {
      await dispatch(register(usertype, country, firstname, lastname, email, password) as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
    setTimeout(() => {
      const url = `/`;
      navigate(url);
    }, 2000);
  }


  //Validations

  const validateName = (value: string) => {
    if (!/^[A-Za-z]+$/.test(value)) {
      setErrors((prev) => ({ ...prev, firstname: 'Name must contain only letters' }));
    } else {
      setErrors((prev) => ({ ...prev, firstname: '' }));
    }
    setfirstname(value);
  };
  const validateLastName = (value: string) => {
    if (!/^[A-Za-z]+$/.test(value)) {
      setErrors((prev) => ({ ...prev, lastname: 'Name must contain only letters' }));
    } else {
      setErrors((prev) => ({ ...prev, lastname: '' }));
    }
    setlastname(value);
  };
  const validateEmail = (value: string) => {
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setErrors((prev) => ({ ...prev, email: 'Invalid email format' }));
    } else {
      setErrors((prev) => ({ ...prev, email: '' }));
    }
    setemail(value);
  };
  const validatePassword = (value: string) => {
    if (!/^(?=.*[A-Z])(?=.*\d{4,})(?=.*[a-z]{4,}).{8,}$/.test(value)) {
      setErrors((prev) => ({ ...prev, password: 'Must contain 1 uppercase, 4 lowercase, 4 digits & be at least 8 characters' }));
    } else {
      setErrors((prev) => ({ ...prev, password: '' }));
    }
    setpassword(value);
  };


  const isFormValid = usertype && password && firstname && lastname && country && email && Object.values(errors).every((error) => !error);
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/register.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div className="main-body">

      {/* Help Bar */}
      <div className="login-help-bar">
        <a
          title="help"
          onClick={(e) => openWindow(e, IUrl)}
          className="app-help-link"
        >
          Help for this Page
          <i className="pi pi-question-circle"></i>
        </a>
      </div>

      {/* Register Page */}
      <div
        className="flex align-items-center justify-content-center"
        style={{
          maxHeight: '100vh',
          padding: '1rem'
        }}
      >

        {/* Register Card */}
        <div
          className="surface-card shadow-4 border-round-3xl p-4 md:p-5"
          style={{
            width: '100%',
            maxWidth: '850px'
          }}
        >

          {/* Header */}
          <div className="text-center mb-4">

            <img
              src={imageName}
              alt="logo"
              height={55}
              className="mb-3"
            />

            <h2 className="m-0 text-900">
              Register a new membership
            </h2>

            <p className="text-600 mt-2">
              Create your GearForNeed account
            </p>

          </div>

          {/* Form Grid */}
          <div className="grid">

            {/* Role */}
            <div className="col-12 md:col-6">

              <label className="block font-semibold mb-2">
                Select Role
              </label>

              <Dropdown
                value={usertype}
                data-testid="usertype-dropdown"
                onChange={(e) => setusertype(e.value)}
                options={useroptions}
                optionLabel="labels"
                placeholder="Select Role"
                className="w-full"
              />

            </div>

            {/* Country */}
            <div className="col-12 md:col-6">

              <label className="block font-semibold mb-2">
                Country
              </label>

              <Dropdown
                value={country}
                data-testid="country-dropdown"
                onChange={(e) => setcountry(e.value)}
                optionValue="CountryID"
                optionLabel="CountryName"
                placeholder="Select Country"
                className="w-full"
                options={datas}
              />

            </div>

            {/* First Name */}
            <div className="col-12 md:col-6">

              <label className="block font-semibold mb-2">
                First Name
              </label>

              <InputText
                id="firstname"
                type="text"
                data-testid="firstname-input"
                placeholder="Enter First Name"
                className={`w-full ${errors.firstname ? 'p-invalid' : ''
                  }`}
                value={firstname}
                onChange={(e) => validateName(e.target.value)}
              />

              {errors.firstname && (
                <small className="p-error">
                  {errors.firstname}
                </small>
              )}

            </div>

            {/* Last Name */}
            <div className="col-12 md:col-6">

              <label className="block font-semibold mb-2">
                Last Name
              </label>

              <InputText
                id="lastname"
                type="text"
                data-testid="lastname-input"
                placeholder="Enter Last Name"
                className={`w-full ${errors.lastname ? 'p-invalid' : ''
                  }`}
                value={lastname}
                onChange={(e) =>
                  validateLastName(e.target.value)
                }
              />

              {errors.lastname && (
                <small className="p-error">
                  {errors.lastname}
                </small>
              )}

            </div>

            {/* Email */}
            <div className="col-12 md:col-6">

              <label className="block font-semibold mb-2">
                Email Address
              </label>

              <InputText
                id="email"
                type="email"
                data-testid="email-input"
                placeholder="Enter Email Address"
                className={`w-full ${errors.email ? 'p-invalid' : ''
                  }`}
                value={email}
                onChange={(e) =>
                  validateEmail(e.target.value)
                }
              />

              {errors.email && (
                <small className="p-error">
                  {errors.email}
                </small>
              )}

            </div>

            {/* Password */}
            <div className="col-12 md:col-6">

              <label className="block font-semibold mb-2">
                Password
              </label>

              <InputText
                id="password"
                type="password"
                data-testid="password-input"
                placeholder="Enter Password"
                className={`w-full ${errors.password ? 'p-invalid' : ''
                  }`}
                value={password}
                onChange={(e) =>
                  validatePassword(e.target.value)
                }
              />

              {errors.password && (
                <small className="p-error">
                  {errors.password}
                </small>
              )}

            </div>

          </div>

          {/* Terms */}
          <div className="flex align-items-center mt-3 mb-4">

            <Checkbox
              id="termsandconditions"
              onChange={(e) =>
                setChecked(e.checked || false)
              }
              checked={checked}
              className="mr-2"
              data-testid="checkbox-agree"
            />

            <label htmlFor="termsandconditions">
              I agree to the Terms & Conditions
            </label>

          </div>

          {/* Register Button */}
          <GFNButton
            label="Register"
            onClick={regsdata}
            disabled={!isFormValid || !checked}
            icon="pi pi-user-plus"
            testId="register-btn"
            fullWidth
            buttonType="primary"
          />

          {/* Bottom Link */}
          <div className="text-center mt-4">

            <span className="text-600">
              Already have an account?
            </span>

            <Link
              to="/"
              data-testid="member-link"
              className="ml-2 text-blue-500 font-semibold no-underline"
            >
              Login Here
            </Link>

          </div>

        </div>

      </div>

      {/* Toast */}
      <Toast ref={toast} />

    </div>
  );
}

